<div class="form-group">
    <label>Must contain</label>
    <tag-input [(ngModel)]="fieldOptions.abbreviation"
               [identifyBy]="'id'"
               [displayBy]="'name'"
               (ngModelChange)="dataChangedEvent($event)"
               (onAdd)="onAbbreviationAdded($event)"
               [placeholder]="'or another word or phrase '"
               [secondaryPlaceholder]="'Word or phrase '"
               theme="bootstrap">
        <tag-input-dropdown [autocompleteItems]="abbreviationItems"
                            [identifyBy]="'id'"
                            [displayBy]="'name'">
        </tag-input-dropdown>
    </tag-input>
</div>